if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);

function init() {
  // initCursor();
  initNav();
}

window.addEventListener("load", function () {
  init();
});

let mm = gsap.matchMedia();

mm.add("(min-width: 768px)", () => {
  ScrollSmoother.create({
    smooth: 1,
    effects: true,
    smoothTouch: 0.1,
    normalizeScroll: true,
  });

  // IMPACT & SYMPTONS SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-impact-symptoms--big", {
      xPercent: -400,
      ease: "none",
    })
    .to(
      "#scrolling-header-impact-symptoms--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-impact-symptoms--big",
    animation: scrolling_headers_animation,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
  });

  // IMPACT INFO DESCRIPTION 1 ANIMATION
  const impact_info_description_1_animation = gsap.timeline({ paused: "true" });
  impact_info_description_1_animation.to(".impact__info span", {
    y: "0%",
    stagger: 0.1,
  });

  ScrollTrigger.create({
    trigger: ".impact__info__title",
    animation: impact_info_description_1_animation,
    start: "top 70%",
    duration: 0.3,
  });

  // IMPACT INFO DESCRIPTION 3 ANIMATION
  const impact_info_description_3_animation = gsap.timeline({ paused: "true" });
  impact_info_description_3_animation.to(".impact__info__description-3 span", {
    y: "0%",
    stagger: 0.1,
  });

  ScrollTrigger.create({
    trigger: ".impact__info__description-3",
    animation: impact_info_description_3_animation,
    start: "top 80%",
  });

  // TRANSMISSION & ARRIVAL SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation_disease_war = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-transimission-arrival--big", {
      xPercent: -400,
      ease: "none",
    })
    .to(
      "#scrolling-header-transimission-arrival--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-transimission-arrival--big",
    animation: scrolling_headers_animation_disease_war,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
  });

  // TRANSMISSION INFO DESCRIPTION 1 ANIMATION
  const transmission__info__description__animation = gsap.timeline({
    paused: "true",
  });
  transmission__info__description__animation.to(".transmission__info span", {
    y: "0%",
    stagger: 0.1,
  });

  ScrollTrigger.create({
    trigger: ".transmission__info__title",
    animation: transmission__info__description__animation,
    start: "top 70%",
    duration: 0.3,
  });

  // CHOLERA REAPER IMAGE ANIMATION
  const cholera_reaper_animation = gsap.timeline({ paused: "true" });
  cholera_reaper_animation
    .to(".cholera-reaper__image", {
      x: window.innerWidth,
      ease: "easeOut",
    })
    .to(
      ".cholera-reaper__image",
      {
        scale: 1,
      },
      0
    );

  ScrollTrigger.create({
    trigger: ".cholera-reaper__wrapper",
    animation: cholera_reaper_animation,
    start: "top 50%",
    end: "bottom +=600",
    scrub: 1,
  });

  // TRANSMISSION DESCRIPTION 2 ANIMATION
  const transmission__info__description_2__animation = gsap.timeline({
    paused: "true",
  });
  transmission__info__description_2__animation.to(
    ".transmission__wrapper-2 span",
    {
      y: "0%",
      stagger: 0.1,
    }
  );

  ScrollTrigger.create({
    trigger: ".transmission__wrapper-2",
    animation: transmission__info__description_2__animation,
    start: "top 90%",
    duration: 0.3,
  });

  // EXPOSURE, RACE & SOCIAL POSITION SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation_beriberi = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-exposure--big", { xPercent: -400, ease: "none" })
    .to(
      "#scrolling-header-exposure--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-exposure--big",
    animation: scrolling_headers_animation_beriberi,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
  });

  // EXPOSURE INFO DESCRIPTION 1 ANIMATION
  const exposure__info__animation = gsap.timeline({
    paused: "true",
  });
  exposure__info__animation.to(".exposure__info span", {
    y: "0%",
    stagger: 0.1,
    duration: 0.3,
  });

  ScrollTrigger.create({
    trigger: ".exposure__info__title",
    animation: exposure__info__animation,
    start: "top 70%",
  });

  // EXPOSURE GRAPH ANIMATION
  const exposure_graph_animation = gsap
    .timeline({ paused: "true" })
    .to(".tableauPlaceholder", {
      opacity: 1,
      duration: 1,
    });

  ScrollTrigger.create({
    trigger: ".tableauPlaceholder",
    animation: exposure_graph_animation,
    start: "top 70%",
  });

  // EXPERIMENTAL TREATMENTS SCROLLING HEADERS ANIMATION
  const scrolling_headers_animation_experimental_treatments = gsap
    .timeline({ paused: "true" })
    .to("#scrolling-header-experimental-treatments--big", {
      xPercent: -400,
      ease: "none",
    })
    .to(
      "#scrolling-header-experimental-treatments--small",
      { xPercent: 400, ease: "none" },
      "<"
    );

  ScrollTrigger.create({
    trigger: "#scrolling-header-experimental-treatments--big",
    animation: scrolling_headers_animation_experimental_treatments,
    start: "top 80%",
    end: "bottom -=500",
    scrub: 1,
  });

  // EXPERIMENTAL TREATMENTS TEXT ANIMATION
  const experimental_treatments_animation = gsap
    .timeline({ paused: "true" })
    .to(".experimental__info span", {
      y: "0%",
      stagger: 0.1,
    });

  ScrollTrigger.create({
    trigger: ".experimental__info__title",
    animation: experimental_treatments_animation,
    start: "top 70%",
  });
});

// Draw Hero Image
const hero_tl = gsap.timeline();
hero_tl
  .from(".hero__image--cholera path", {
    duration: 4,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)",
    fill: "transparent",
  })
  .to(
    ".hero__image",
    {
      autoAlpha: 1,
    },
    0
  )
  .to(
    ".hero__image .cls-1",
    {
      fill: "#333",
      duration: 4,
    },
    4
  )
  .to(
    ".hero__image .cls-2",
    {
      fill: "#555",
      duration: 4,
    },
    "<"
  );

// Draw Poppy Image
const poppy_tl = gsap.timeline({ paused: true });
poppy_tl.from("#experimental__image--poppy path", {
  duration: 8,
  drawSVG: "0%",
  ease: "slow(0.7, 0.7, false)",
  fill: "transparent",
});
poppy_tl.to(
  ".experimental__image__wrapper-1",
  {
    opacity: 1,
  },
  0
);

ScrollTrigger.create({
  trigger: ".section--experimental-treatments",
  animation: poppy_tl,
  start: "top 30%",
});

// Draw Lime Image
const lime_tl = gsap.timeline({ paused: true });
lime_tl.from("#experimental__image--lime path", {
  duration: 5,
  drawSVG: "0%",
});
lime_tl.to(
  ".experimental__image__wrapper-2",
  {
    opacity: 1,
  },
  0
);

ScrollTrigger.create({
  trigger: ".experimental__image--lime",
  animation: lime_tl,
  start: "top 50%",
});

// Draw Theme Lead In
const theme_lead_in_animation_tl = gsap.timeline({ paused: "true" });
theme_lead_in_animation_tl.from(".theme-lead-in__image path", {
  duration: 4,
  drawSVG: "0%",
  ease: "slow(0.7, 0.7, false)",
});
theme_lead_in_animation_tl.to(
  ".theme-lead-in__wrapper",
  {
    opacity: 1,
  },
  0
);

theme_lead_in_animation_tl.to(".theme-lead-in__image .cls-1", {
  fill: "#191919",
  duration: 2,
});

theme_lead_in_animation_tl.to(
  ".theme-lead-in__arrow-right",
  {
    width: "100%",
    duration: 0.5,
  },
  "<.5"
);

theme_lead_in_animation_tl.to(
  ".theme-lead-in__next",
  {
    opacity: 1,
    duration: 1,
  },
  "<+.5"
);

ScrollTrigger.create({
  trigger: ".section--theme-lead-in",
  animation: theme_lead_in_animation_tl,
  start: "top 20%",
});
